var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { cookie } from '../web';
import { doWhenP } from '../utils';
import { getCacheItem, setCacheItem } from '../cache';
import { getRequestId, updateRequest } from '../dataLayer';
export const VWO_CACHE_KEY = 'vwoData';
export const VWO_UUID_KEY = '_vwo_uuid';
export function getVwoId(fallback = false) {
    const uuid = cookie(VWO_UUID_KEY) || null;
    if (!uuid && fallback) {
        return (window === null || window === void 0 ? void 0 : window._vwo_uuid) || null;
    }
    return uuid;
}
export function getVwoExperiments() {
    const regex = /^_vis_opt_exp_(\d+)_combi=(\d+)$/;
    const cookies = document.cookie.split('; ');
    const expts = [];
    for (const c of cookies) {
        const res = c.match(regex);
        if ((res === null || res === void 0 ? void 0 : res.length) !== 3)
            continue;
        expts.push({
            experiment_id: Number(res[1]),
            variation_id: Number(res[2]),
        });
    }
    return expts;
}
export function sendVwoData(requestId_1) {
    return __awaiter(this, arguments, void 0, function* (requestId, fallback = false) {
        var _a, _b, _c;
        const req = {};
        const uuid = getVwoId(fallback);
        const expts = getVwoExperiments();
        const cache = (getCacheItem(VWO_CACHE_KEY) || {});
        if (uuid && uuid !== cache.requestId && requestId !== cache.requestId) {
            req.vwo = { uuid };
        }
        if (requestId !== cache.requestId) {
            req.vwo_experiments = expts;
        }
        else {
            const exptsMap = {};
            (_a = cache.expts) === null || _a === void 0 ? void 0 : _a.forEach(({ experiment_id, variation_id }) => {
                exptsMap[experiment_id] = variation_id;
            });
            for (const expt of expts) {
                const v = exptsMap[expt.experiment_id];
                if (typeof v !== 'number' || v !== expt.variation_id) {
                    if ((_b = req.vwo_experiments) === null || _b === void 0 ? void 0 : _b.length) {
                        req.vwo_experiments.push(expt);
                    }
                    else {
                        req.vwo_experiments = [expt];
                    }
                }
            }
        }
        if (!req.vwo && !((_c = req.vwo_experiments) === null || _c === void 0 ? void 0 : _c.length))
            return;
        updateRequest(requestId, req).then(() => {
            setCacheItem(VWO_CACHE_KEY, {
                requestId,
                uuid,
                expts: [...(req.vwo_experiments || []), ...(cache.expts || [])],
            });
        });
    });
}
export function run() {
    return __awaiter(this, arguments, void 0, function* (maxInterval = 10000) {
        const handlePredicate = () => !!(getRequestId() && getVwoId(false));
        return doWhenP(handlePredicate, maxInterval)
            .then(() => sendVwoData(getRequestId(), false))
            .catch(() => sendVwoData(getRequestId(), true));
    });
}
//# sourceMappingURL=vwoData.js.map